import React from "react";
import { Navigate, Outlet } from "react-router-dom";

// A simple guard that reads auth state each render.
// It avoids keeping stale state inside this component so after logout
// the navigation will immediately redirect to /login.
const PrivateRoute = () => {
  try {
    const token = localStorage.getItem("token");
    const authenticated = JSON.parse(localStorage.getItem("authenticated"));

    // Consider user authenticated if we have a token or an explicit flag
    const isAuth = !!token || !!authenticated;

    return isAuth ? <Outlet /> : <Navigate to="/login" replace />;
  } catch (e) {
    return <Navigate to="/login" replace />;
  }
};

export default PrivateRoute;
